import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=2a9a6ddc"
import script from "./CustomSearch.vue?vue&type=script&lang=js"
export * from "./CustomSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports